import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
  nameBlock: {
    margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? '0 20px 0 0' : '0 0 0 20px',
    display: 'flex',
    flexDirection: 'row',
  },
  userName: {
    color: theme.palette.text.primary,
  },
  userRoles: {
    paddingTop: 5,
    color: theme.palette.text.secondary,
  },
  menuItemText: {
    color: theme.palette.grey[100],
  },
  menu: {
    marginTop: 40,
    width: 200,
    boxShadow: '0px 1px 14px #00000014',
    border: `1px solid ${theme.palette.grey[800]}`,
    borderRadius: 10,

    paddingBottom: 10,
  },
  arrowButton: {
    padding: 2,
    marginTop: 4,
    // marginLeft: 10,
    margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? '0 10px 0 0' : '0 0 0 10px',
  },
  menuItemIcon: {
    height: 20,
    width: 20,
    margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? '0 0 0 15px' : '0 15px 0 0',
    "& svg": {
      width: "100%",
      // height: "100%"
    }
  }
}));
